import "./style.css";
import { RiArrowDownSLine } from "react-icons/all";

function termsandcontitionspriv() {
    return (
        <div id="wrapper-page">
            <div className="container">
                <div className="row">
                    <div className="col-12 text_terms">
                        <h1>
                            KONTRATA PËR MBAJTJEN DHE PËRDORIMIN E PARASË
                            ELEKTRONIKE
                        </h1>
                        <h2>KUSHTET E PËRGJITHSHME </h2>
                        <p>
                            Përdoruesi është i mendimit se Emetuesi IFJB CAPITAL
                            SH.P.K ka kualifikimet, përvojën dhe aftësitë e
                            nevojshme për t'i ofruar shërbime Përdoruesit
                        </p>
                        <p>
                            Emetuesi IFJB CAPITAL SH.P.K është dakord t'i ofrojë
                            shërbime të tilla Përdoruesit sipas termeve dhe
                            kushteve të përcaktuara në këtë Kontratë, të cilat
                            paraqesin një përmbledhje të përgjithshme të të
                            drejtave, detyrimeve si dhe kushteve për përdorimin
                            e shërbimit të ofruar nga Emetuesi IFJB CAPITAL
                            SH.P.K.
                        </p>
                        <p>
                            Përdoruesi duhet që me kujdes të lexoj ketë kontratë
                            dhe të konfirmoj pranimin e këtyre kushteve dhe
                            termeve para se Përdoruesi të regjistrohet në
                            sistem, të hap një llogari me Emetuesin IFJB CAPITAL
                            SH.P.K, dhe përdorimin e shërbimeve tjera të dhëna
                            nga Emetuesi IFJB CAPITAL SH.P.K.
                        </p>
                        <p>
                            Me fillimin e përdorimit të shërbimeve të Emetuesit
                            IFJB CAPITAL SH.P.K, Përdoruesi konfirmon se i ka
                            lexuar dhe kuptuar termet dhe kushtet e kësaj
                            kontrate elektronike, të specifikuar në vijim të
                            kësaj kontrate dypalëshe.
                        </p>
                        <h5>Palët në kontratë </h5>
                        <p>
                            Kjo kontratë lidhet në Prishtinë, nga dhe ndërmjet:
                        </p>
                        <h5>
                            <span className="leftpadd">
                                1. Institucioni Financiar IFJB CAPITAL SH.P.K,
                            </span>
                            i licencuar nga BQK, me NUI: 810797623, me adrës Rr.
                            Perandori Dioklecian Nr.72 10000 Prishtinë,
                            Republika e Kosovës,
                        </h5>
                        <p>Dhe</p>
                        <h5>
                            <span className="leftpadd">
                                2. Përdoruesi: Emri i biznesit:
                            </span>
                            , me NUI: 00000, Rr. Xxxx, nr., teli:
                        </h5>
                        <h5>Njihni Klientin tuaj</h5>
                        <p>
                            Duke nënshkruar këtë Kontratë, Përdoruesi bie dakord
                            që Emetuesit IFJB CAPITAL SH.P.K, si në vetvete
                            ashtu përmes palëve të treta nëse aplikohet, mund të
                            verifikojë dhe vlerësojë identitetin e Përdoruesit
                            dhe përfituesve të tij, edhe aktivitetin, origjinën
                            e fondeve, rreziqet dhe çdo informacion tjetër që
                            kërkohet për të e njohur Përdoruesin. Përdoruesi
                            merr përsipër t'i sigurojë Emetuesit IFJB CAPITAL
                            SH.P.K të gjithë informacionin dhe dokumentet e
                            kërkuara prej tij për qëllimet e njohjes së
                            Përdoruesit brenda afati i përcaktuar nga Emetuesit
                            IFJB CAPITAL SH.P.K dhe në formën dhe gjuhën e
                            përcaktuar nga Emetuesit IFJB CAPITAL SH.P.K. Nëse
                            Emetuesit IFJB CAPITAL SH.P.K nuk mund ta njohë si
                            duhet dhe plotësisht Përdoruesin, kjo Kontrate nuk
                            është përfunduar dhe, nëse është lidhur, ajo është
                            menjëherë dhe pa njoftim paraprak e përfunduar.
                        </p>
                        <p>
                            Përdoruesi bie dakord dhe merr përsipër në çdo kohë
                            me kërkesë të Emetuesit IFJB CAPITAL SH.P.K, për të
                            përditësuar dhe/ose dorëzuar tek Emetuesit IFJB
                            CAPITAL SH.P.K, informacione dhe dokumente shtesë
                            rreth identitetin e Përdoruesit dhe përfituesve të
                            tij, origjinën e fondeve të përdorura, aktivitetet
                            dhe informacione të tjera të kërkuara nga Emetuesit
                            IFJB CAPITAL SH.P.K për t'u njohur me Përdoruesin,
                            brenda afati kohor i specifikuar nga Emetuesit IFJB
                            CAPITAL SH.P.K dhe në formën dhe gjuhën e treguar
                            nga Emetuesit IFJB CAPITAL SH.P.K.
                        </p>
                        <p>
                            Me ndryshimin e të dhënave të treguara nga
                            Përdoruesi gjatë procedurës së fundit të marrjes për
                            të njohur Përdoruesin, Përdoruesi merr përsipër të
                            njoftojë Emetuesit IFJB CAPITAL SH.P.K. menjëherë
                            dhe jo më vonë se brenda një (1) dite pune me
                            shkrim, përfshirë me e-mail, dhe siguron dokumentet
                            që lidhen me ndryshime të tilla. Në rast të
                            mospërmbushjes së detyrimeve e parashikuar në këtë
                            klauzolë, Përdoruesi është përgjegjës i vetëm për të
                            gjitha pasojat që dalin nga mos-komunikimi në kohën
                            e duhur dhe pajtohet që veprimet e Emetuesit IFJB
                            CAPITAL SH.P.K, i kryer duke përdorur detajet e
                            fundit të kontaktit të njohura për Emetuesin IFJB
                            CAPITAL SH.P.K dhe autorizimet, do të konsiderohet
                            se janë kryer si duhet.
                        </p>
                        <h5>Subjekti i Kontratës </h5>
                        <p>
                            Sipas kësaj Kontrate Emetuesin IFJB CAPITAL SH.P.K
                            merr përsipër të hapë llogari të parasë elektronike
                            për Përdoruesin, pranon fondet nga Përdoruesi,
                            lëshoni shumën e duhur të parave elektronike dhe i
                            kreditoni ato në llogarinë e hapur nga Përdoruesi,
                            ekzekuton udhëzimet e Përdoruesi për transferimin
                            dhe kthimin e parasë elektronike dhe transaksione të
                            tjera pagese, për t'i mundësuar Përdoruesit të
                            menaxhojë llogarinë me mjete elektronike dhe të
                            kryejë operacione të tjera të kryera nga Emetuesi,
                            dhe Përdoruesi merr përsipër t'i paguajë Emetuesit
                            për shërbimet e ofruara dhe operacionet e kryera.
                        </p>
                        <h5>1. Përkufizimet</h5>
                        <p>
                            <span>1. Emetuesi</span> – nënkupton institucionin
                            financiar IFJB CAPITAL SH.P.K, me numër Unik
                            Identifikues 810797623 me me adresë në Rruga
                            Perandori Dioklecian Nr.72, 10 000 Prishtinë,
                            Republika e Kosovës, për ushtrimin e veprimtarisë së
                            emetimit të parasë elektronike, që në bazë të kësaj
                            kontrate i emeton mbajtësit për përdorim,
                            instrumentin e parasë elektronike;
                        </p>
                        <p>
                            <span>2. Llogaria e Emetuesit </span> - nënkupton
                            llogarinë e hapur nga personat fizik apo personat
                            juridik e cila i mundëson Përdoruesit që të kryej
                            veprimet e parapara në nenin 2 të kësaj Kontrate.
                        </p>
                        <p>
                            <span>3. Mbajtësi ose Përdoruesi</span> - nënkupton
                            personin fizik që arrin moshën madhore moshën 18
                            vjeç, ose juridik i cili në bazë të kësaj kontrate
                            ka llogari të Emetuesi IFJB CAPITAL SH.P.K të
                            regjistruar në emrin e tij;
                        </p>
                        <p>
                            <span>4. Transaksioni i Pagesës</span> - nënkupton
                            veprimin financiar që konsiston në debitimin e
                            llogarisë së mbajtësit në IFJB CAPITAL SH.P.K ose në
                            bankën e ndërlidhur dhe kreditimin e llogarisë së
                            Tregtarit ose Përfituesit tjetër për vlerën e
                            mallit/shërbimit;
                        </p>
                        <p>
                            <span>5. Faturat</span> – nënkupton institucionet,
                            organizatat apo të ngjashme që lëshojnë një faturë
                            mujore apo tjetër kundrejt së cilës ju krijoni
                            detyrim pagese;
                        </p>
                        <p>
                            <span>6. Paguaj</span> – nënkupton butoni përmes së
                            cilit ju drejtoheni tek mundësia e pagesës së mallit
                            a shërbimit në dyqane, restorante, hotele, kafeteri
                            apo çfarëdo subjekti ekonomik;
                        </p>
                        <p>
                            <span>7. Transfero</span> – nënkupton hapësira vetë
                            shërbyese për transferimin e mjeteve nga llogaria
                            juaj tek Emetuesi IFJB CAPITAL SH.P.K në llogarinë e
                            një personi fizik apo juridik që mbanë llogari
                            aktive tek Emetuesi IFJB CAPITAL SH.P.K;
                        </p>
                        <p>
                            <span>8. Debitimi</span> - nënkupton zvogëlimin e
                            fondeve të llogarisë së Mbajtësit si pasojë e një
                            transaksioni të kryer nga ana e Mbajtësit në dobi të
                            Tregtarit/Përfituesit;
                        </p>
                        <p>
                            <span>9. Kreditimi</span> - nënkupton çdo
                            transaksion hyrës në llogarinë e Mbajtësit dhe që
                            kryhet me Para Elektronike gjithnjë duke u
                            verifikuar dhe ose monitoruar nga Emetuesi;
                        </p>
                        <p>
                            <span>10. Tarifat</span> - pagesat për IFJB CAPITAL
                            SH.P.K në emër të shërbimit të kryer;
                        </p>
                        <p>
                            <span>11. Pronësia intelektuale</span> – nënkupton
                            një apo të gjitha patentave, markave tregtare,
                            dizajneve industriale, të drejtave të autorit,
                            “know-how”, rrjedhës së punës, apo të drejtave tjera
                            të pronësisë intelektuale, qoftë të regjistruara apo
                            paregjistruara;
                        </p>
                        <p>
                            <span>12. Të dhëna personale</span> – kanë të
                            njëjtin kuptim si në Ligjin Nr. 06/L-082 për
                            Mbrojtjen e të Dhënave Personale dhe aktet tjera
                            sekondare.
                        </p>
                        <p>
                            <span>13. Nënshkrimi</span> – nënshkrimi elektronik
                            ose SMS kodi/token-i identifikues elektronik që i
                            plotëson që mundëson në mënyrë të qarte idenfikimin
                            e përdoruesit.
                        </p>
                        <p>
                            <span>14 Nënshkruesi</span> - personi që mban të
                            dhënat për krijimin e nënshkrimit dhe vepron qoftë
                            në emër të vet apo në emër të personit që e
                            përfaqëson;
                        </p>
                        <p>
                            <span>15. Kontrata elektronike</span> – nënkupton
                            këtë kontratë e cila është bërë tërësisht ose
                            pjesërisht me komunikim elektronik apo në formë
                            elektronike dhe e plotfuqishme sipas nenit 11 të
                            ligjit nr. 04/L-094 për Shërbimet e Shoqërisë
                            Informatike.
                        </p>
                        <p>
                            <span>16. Para elektronike</span> – vlera monetare e
                            ruajtur në formë elektronike, duke përfshirë edhe
                            formën magnetike, siç paraqitet nga kërkesa ndaj
                            emetuesit, që emetohet pas pranimit të fondeve me
                            qëllim të kryerjes së transaksioneve të pagesave dhe
                            e cila pranohet si mjet i pagesës nga personat tjerë
                            përveç emetuesit të parasë elektronike;
                        </p>
                        <p>
                            <span>17. Instrument i parasë elektronike</span> –
                            është një instrument pagese, i ndryshëm nga
                            instrumenti i pagesave me qasje në distancë, i cili
                            ruan vlera monetare në formë elektronike dhe i
                            mundëson mbajtësit të kryejë pagesa elektronike. Ky
                            instrument mund të rimbushet me vlera monetare sa
                            herë që është e nevojshme.
                        </p>
                        <p>
                            <span>18. Autentifikim i Përdoruesit</span> -
                            procedura e verifikimit të identitetit të personit
                            fizik ose juridik bazuar në përdorimin e dy ose më
                            shumë elementeve të kategorizuar si njohuri (p.sh.
                            fjalëkalim statik, kod, numër identifikimi personal)
                            ose si posedim (p.sh. shenja, kartë inteligjente,
                            numër telefoni ), dhe qenësia (p.sh. karakteristikat
                            bimoetrike të tilla si gjurmët e gishtërinjve).
                        </p>
                        <p>
                            <span>19. Sistem dhe / apo Aplikacion</span> - një
                            zgjidhje softuerike që mund të shkarkohet nga IOS,
                            Andoroi apo të qaset nga faqja e internetit të
                            Emetuesit IFJB CAPITAL SH.P.K, e zhvilluar nga
                            Emetuesi IFJB CAPITAL SH.P.K dhe e përdorur për
                            ofrimin e shërbimeve e Emetuesit IFJB CAPITAL
                            SH.P.K.
                        </p>
                        <p>
                            <span>
                                Neni 2. Hapja e llogarisë me Emetuesin dhe lloji
                                i instrumentit të pagesave në të cilin ruhet
                                paraja elektronike
                            </span>
                        </p>
                        <p>
                            2.1 Emetuesi IFJB CAPITAL SH.P.K ofron dy lloje të
                            llogarive: llogari për persona fizik (llogaria
                            personale) dhe llogari për persona juridik (llogaria
                            e organizatës ose llogaria e biznesit).
                        </p>
                        <p>
                            2.2 Hapja e llogarisë për
                            <span> person juridik</span> nga Emetuesi IFJB
                            CAPITAL SH.P.K ndahet në dy faza:
                        </p>
                        <p className="leftpadd">
                            2.2.1 Në fazën e parë duhet të ofrohen:
                        </p>
                        <p className="leftpadd">
                            a) Emri i Biznesit dhe Numri Fiskal; <br />
                            b) Emri dhe mbiemri i perfaqesuesit apo personit te
                            autorizuar per hapje te llogarise; <br />
                            c) Numri i telefonit, ku do të dërgohet kodi
                            verifikues me SMS; <br />
                            d) Fjalekalimi perkatesisht konfirmimi i tij dhe
                            Personal Identification Number (PIN); <br />
                            c) Kodin aktivizues që reflekton nënshkrimin sipas
                            përkufizimeve në ligjin nr. 04/L-094 <br />
                            Për Shërbimet e Shoqërisë Informatike, ose
                            përkufizimit në këtë kontrate. <br />
                            2.2.2 Në fazën e dytë duhet të vërtetohet identiteti
                            i Klientit, përmes verifikimit tek Emetuesi IFJB
                            CAPITAL SH.P.K, ku duhet të: <br />
                            a) Shkruhet emri dhe mbiemri i Klientit; <br />
                            b) Bashkëngjitet një kopje (fotografi në të dy anët)
                            e letërnjoftimit ose pasaportës dhe një foto çasti
                            (Ang. selfie); <br />
                            c) Një kopje te faturës se ujit apo energjisë
                            elektrike për te dëshmuar adresën; <br />
                            d) Kopjen e certifikatës së biznesit ose
                            organizatës, nëse Përdoruesi është duke hapur
                            llogari biznesi (organizate), së bashku me kopjen e
                            autorizimit të noterizuar që vërteton se aplikuesi
                            është i autorizuar për të për të hapur llogari.
                        </p>
                        <p>
                            2.3 Përdoruesi do t’i japë Emetuesit IFJB CAPITAL
                            SH.P.K çdo informacion dhe/ose dokument origjinal që
                            mund të kërkohet nga Emetuesit IFJB CAPITAL SH.P.K
                            sipas ligjeve dhe rregulloreve në fuqi (origjinal,
                            me afat dhe dokument me fotografi), si dhe dokumente
                            të tjerë të cilët konsiderohen të nevojshëm për
                            qëllimin e ofrimit të shfrytëzimit të shërbimit te
                            Emetuesit IFJB CAPITAL SH.P.K.
                        </p>
                        <p className="leftpadd">
                            2.3.1 Kur përfundon verifikim i regjistrimit apo
                            hapjes së llogarisë në sistem, krijohet profili i
                            Përdoruesit, e cili është personal dhe vetëm
                            Përdoruesi ka të drejt të shfrytëzon per qëllimin e
                            krijimit. <br />
                            2.3.2 Regjistrimi apo hapja e llogarisë në sistem
                            është konfirmim se Përdoruesi shpreh pëlqimin e
                            tij/saje me termet dhe kushtet e kontratës, dhe
                            zotohet me përgjegjësi të plotë të veproj sipas
                            tyre. <br />
                            2.3.3 Emetuesi IFJB CAPITAL SH.P.K siguron shërbimet
                            tek personat që kane arritur moshën 18 vjeç.
                        </p>
                        <p>
                            2.4 Përdorimi i shërbimeve të Emetuesit IFJB CAPITAL
                            SH.P.K
                        </p>
                        <p className="leftpadd">
                            2.4.1 Llogaria e Emetuesit IFJB CAPITAL SH.P.K do të
                            aktivizohet dhe bëhet e qasshme vetëm pas
                            verifikimit të identitetit të Përdoruesit nga
                            zyrtarët e Emetuesit IFJB CAPITAL SH.P.K, sipas
                            procedurës të shprehur tek paragrafi 2 i këtij neni
                            të kësaj kontrate. <br />
                            2.4.2 Përdoruesi mund të posedon vetëm një llogari
                            kryesore individuale në Emetuesi IFJB CAPITAL
                            SH.P.K. Përdoruesi po ashtu ka të drejtë të ketë
                            edhe një tjetër llogari në emër të biznesit apo
                            organizatës për të cilën e përfaqëson. <br />
                            2.4.3 Në llogarinë e Emetuesit IFJB CAPITAL SH.P.K
                            Përdoruesi mund të qaset permese njërës nga mënyrat
                            e autentifikimit kur përdoruesi qaset në llogari për
                            të kryer shërbimet e lejuara, dhe të cilat mund të
                            lidhet me rrezikun e mashtrimit në kryerjen e
                            shërbimeve të lejuara ose çdo lloj keqpërdorimi
                            tjetër. <br />
                            2.4.4 Emetuesi IFJB CAPITAL SH.P.K merr për sipër të
                            zbatoj një shërbim vetëm pasi të jetë aktivizuar
                            llogaria juaj dhe të keni dhënë kodin e konfirmimit
                            të shumës, tarifës (nëse ka) dhe përdoruesit. <br />
                            2.4.5 Emetuesi IFJB CAPITAL SH.P.K ruan të drejtën
                            që në përputhje me aktet e brendshme të Emetuesit
                            IFJB CAPITAL SH.P.K të refuzojë hapjen e një
                            llogarie personale apo biznesi apo edhe ta pezulloj
                            nëse vërehet apo dyshohet për konsumin e veprave të
                            ndaluara, deri në vendimin përfundimtar të Gjykatës.
                        </p>
                        <h5 className="toppadd">
                            Neni 3. Lloji i pajisjes/mjetit në të cilin mbajtësi
                            mund ta përdor për të kryer transaksione
                        </h5>
                        <p>
                            3.1 Për përdorimin e shërbimeve të Emetuesin IFJB
                            CAPITAL SH.P.K është veprim i domosdoshëm hapja e
                            llogarisë se Emetuesit IFJB CAPITAL SH.P.K,
                            nëpërmjet telefonave të mençur, me sistem operativ
                            iOS ose Android nëpërmjet shkarkimit të Aplikacionit
                            dhe/apo përdorimit të Emetuesit IFJB CAPITAL SH.P.K
                            drejtpërdrejtë në webfaqen zyrtare të Emetuesit IFJB
                            CAPITAL SH.P.K. 3.2 Shkarkimi dhe përdorimi i
                            Aplikacionit është pa pagesë. 3.3 Bëhet përjashtim
                            për tarifat e ngarkuara nga operatori mobil dhe/ose
                            ofruesit e shërbimit të internetit për përdorimin e
                            internetit, të cilat nuk bien nën përgjegjësinë e
                            Emetuesit IFJB CAPITAL SH.P.K.
                        </p>
                        <h5>
                            Neni 4. Llojet e transaksioneve të pagesave që mund
                            të kryhen
                        </h5>
                        <p>
                            4.1 Pas hapjes se llogarisë personale, llojet e
                            transaksioneve të pagesave që mund të kryhen nga
                            përdoruesi janë si në vijim:
                        </p>
                        <p className="leftpadd">
                            4.1.1 Përdoruesi mund të depozitojë fonde në
                            llogari, të tërheqë fonde nga Llogaria, mbajnë fonde
                            në llogari, transferojnë, pranojnë dhe kryejnë
                            operacione të tjera sic janë pagesa malli, faturave,
                            të cilat Emetuesit IFJB CAPITAL SH.P.K lejon të
                            ekzekutohet me Llogarinë. <br />
                            4.1.2 Tërheqjes së mjeteve nga llogaria e Emetuesit
                            IFJB CAPITAL SH.P.K në mjete të gatshme (Ang. CASH)
                            nëpërmjet zyrave të Emetuesit IFJB CAPITAL SH.P.K,
                            agjentëve apo bankave të licencuara nga BQK që ju
                            keni llogari bankare, aktive. <br />
                            4.1.3 Fondet në Llogari janë pronë e Përdoruesit,
                            përveç tarifave, humbjeve dhe shuma të tjera të
                            ngjashme të pagueshme për Emetuesin IFJB CAPITAL
                            SH.P.K, siç parashikohet nga kjo Kontratë,
                            marrëveshje të tjera midis palëve ose aktet ligjore.
                            <br />
                            4.1.4 Fondet e mbajtura në llogari janë Para
                            Elektronike. Kur Përdoruesi bën një depozitë dhe/ose
                            pranon para në llogari, Emetuesit IFJB CAPITAL
                            SH.P.K do të lëshojë para elektronike dhe i
                            kreditoni ato në llogari me vlerën nominale të
                            fondeve të depozituara dhe/ose pranuar (pas pagesës
                            së tarifave të Emetuesit IFJB CAPITAL SH.P.K, nëse
                            është e aplikueshme). <br />
                            4.1.5 Paratë Elektronike në llogari nuk konsiderohen
                            si depozitë ose fonde të tjera të ripagueshme; për
                            të Emetuesi IFJB CAPITAL SH.P.K nuk paguan interes
                            dhe nuk siguron përfitime të tjera lidhur me
                            kohëzgjatjen e mbajtjes së Parave Elektronike në
                            llogari. <br />
                            4.1.6 Pranimit të pagesave përmes POS-it virtual
                            (këtu e tutje vPOS).
                        </p>
                        <h5>
                            Neni 5. Pranimi dhe mbrojtja e mjeteve financiare
                            nga Emetuesi IFJB CAPITAL SH.P.K
                        </h5>
                        <p>
                            5.1 Emetuesi IFJB CAPITAL SH.P.K pranon mjetet
                            financiare, i ruan ato në një llogari të veçantë,
                            siç është përcaktuar në Rregulloren e BQK për
                            kapital rregullator dhe ruajtje të fondeve të
                            Institucioneve Financiare Jobankare, dhe i shpërndan
                            ato për klientin, kurdo që:
                        </p>
                        <p className="leftpadd">
                            5.1.1 Keni transferuar një shumë të parave përmes
                            eBanking në Emetuesi IFJB CAPITAL SH.P.K; <br />
                            5.1.2 Keni dhënë urdhër transferi nga llogaria juaj
                            bankare në Emetuesi IFJB CAPITAL SH.P.K; <br />
                            5.1.3 Keni transferuar nga kartela juaj e debitit
                            apo kreditit.
                        </p>
                        <p>
                            5.2 Emetuesi IFJB CAPITAL SH.P.K i parasë
                            elektronike emeton para elektronike për një vlerë
                            (të parasë fizike) të barabartë me vlerën nominale
                            të fondeve të marra nga mbajtësi i parasë
                            elektronike. Mbajtësi i parasë elektronike është
                            pronari i fondeve që pranohen nga emetuesi i parasë
                            elektronike.
                        </p>
                        <h5>
                            Neni 6. Kohëzgjatja e periudhës së përdorimit ose
                            afati i vlefshmërisë së parasë elektronike
                        </h5>
                        <p>
                            6.1 Vlera e parasë elektronike e cilat gjenden në
                            llogarinë tuaj në Emetuesi IFJB CAPITAL SH.P.K do të
                            jenë të vlefshme gjatë tërë kohës dhe vlefshmëria e
                            tyre nuk është e lidhur me periudhë kohore.
                        </p>
                        <p>
                            6.2 Emetuesi IFJB CAPITAL SH.P.K nuk do të shtoj apo
                            zvogëloj vlerën e tyre, pavarësisht kohëzgjatjes së
                            mbajtjes së tyre.
                        </p>
                        <h5>
                            Neni 7. Tërheqja e parasë nga llogaria e Emetuesi
                            IFJB CAPITAL SH.P.K
                        </h5>
                        <p className="leftpadd">
                            7.1 Përdoruesi ka të drejtë të tërheqë para
                            elektronike nga llogaria në çdo kohë, me përjashtim
                            të rasteve kur llogaria dhe/ose ofrimi i shërbimeve
                            të Emetuesit IFJB CAPITAL SH.P.K për Përdoruesin
                            bllokohet ose kufizohet ndryshe në përputhje me këtë
                            Marrëveshje ose marrëveshje të tjera midis Emetuesit
                            IFJB CAPITAL SH.P.K dhe Përdoruesit ose aktet
                            juridike. Gjatë tërheqjes së parave elektronike nga
                            llogaria, shuma të Parave Elektronike të tërhequra
                            nga Përdoruesi (pas zbritjes së tarifave të
                            Institucionit, nëse është e aplikueshme) shlyhet nga
                            Emetuesi IFJB CAPITAL SH.P.K me vlerën nominale dhe
                            transferohet në bankë ose një lloj tjetër llogarie
                            të specifikuar nga Përdoruesi ose të transferuar me
                            metoda të tjera mbështetur nga Emetuesi IFJB CAPITAL
                            SH.P.K. Gjatë afatit të Kontratës.
                            <br /> 7.2 Përdoruesi mund tërheq të gjitha ose një
                            pjesë të Parave Elektronike nga llogaria. Me
                            përfundimin e Kontratës, Përdoruesi mund të tërheqë
                            nga llogaria të gjitha paratë elektronike.
                            <br /> 7.3 Tarifat për përdorimin e Llogarisë,
                            përfshirë tarifat për lëshimin dhe kthimin e Parasë
                            Elektronike, tregohen në ketë kontrate.
                            <br /> 7.4.1 Tarifa për kthimin e Parave Elektronike
                            zbatohet vetëm në rastet e mëposhtme:
                        </p>
                        <p className="leftpaddd">
                            1. kur kthimi kërkohet nga ana e mbajtësit të parasë
                            elektronike përpara përfundimit të kontratës;
                            <br /> 2. kur kontrata përcakton një datë për
                            përfundimin e saj dhe mbajtësi i parasë elektronike
                            e përfundon kontratën, para datës së përfundimit;
                            ose
                            <br /> 3. kur kthimi i fondeve të papërdorura,
                            kërkohet pas më shumë se një viti, nga data e
                            përfundimit të kontratës.
                        </p>
                        <h5>
                            Neni 8. Vlera e Tarifave dhe Provizioneve që Lidhen
                            me Përdorimin e Parasë Elektronike
                        </h5>
                        <p>
                            8.1 Përdoruesi nuk do të paguan tarifa për
                            përdorimin e shërbimeve të Emetuesit IFJB CAPITAL
                            SH.P.K, përveç në rastet e pagesave për
                            institucionet publike, përkatësisht pagesave të
                            cilat kalojnë përmes Departamentit të Thesarit të
                            shtetit, pranimit të pagesave apo transfereve ose
                            tërheqjes së mjeteve nga IFJB CAPITAL SH.P.K dhe
                            kostos eventuale të Visa, Master, Maestro card, etj.
                            për transferimin e parasë elektronike. Këto tarifa,
                            do të bëhen të ditura para konsumimit të shërbimit
                            dhe nëse Klienti nuk pajtohet me çmimin do t’ju
                            jepet mundësia e refuzimit.
                        </p>
                        <p>
                            8.2 Kurdo që Përdoruesi nuk pajtohet me një tarifë
                            të Emetuesit IFJB CAPITAL SH.P.K, i njëjti mund të
                            refuzoni konsumin e shërbimit të Emetuesit IFJB
                            CAPITAL SH.P.K, para se ta konfirmon atë dhe IFJB
                            CAPITAL SH.P.K nuk do ta ngarkon Përdoruesin me
                            shërbimin.
                        </p>
                        <p>
                            8.3 Emetuesi ka të drejtë, për arsye të rëndësishme,
                            të ndryshojë në mënyrë të njëanshme Tarifat, duke
                            informuar Përdoruesin për këtë jo më vonë se 60
                            (gjashtëdhjetë) ditë kalendarike para datës data e
                            hyrjes në fuqi të këtyre ndryshimeve.
                        </p>
                        <p>
                            8.4 Përdoruesi konsiderohet se jep pëlqimin për
                            ndryshimet e specifikuara në pikën 8.3 të Kontratës
                            nëse ai nuk e njofton Emetuesin para se ndryshimet
                            të hyjnë në fuqi se ai nuk pajtohet me to. Nëse
                            Përdoruesi informon se nuk pajtohet me ndryshimet e
                            specifikuara në pikën 8.3 të Kontratës, Përdoruesi
                            ka të drejtë të përfundojë Kontratën para datës në
                            të cilën do të marrin ndryshimet efektin. Nëse
                            Përdoruesi nuk ushtron të drejtën për të përfunduar
                            Kontratën para datës kur ndryshimet hyjnë në fuqi,
                            Përdoruesi konsiderohet se i pranon ndryshimet në
                            Kontratë.
                        </p>
                        <h5>Neni 9. Procedurat e aplikueshme të sigurisë</h5>
                        <p>
                            9.1 Vetëm një fjalëkalim mund të lidhet me Llogarinë
                            e Përdoruesit në çdo kohë dhe vetëm Përdoruesi mund
                            të përdorë llogarinë e Emetuesit IFJB CAPITAL SH.P.K
                            me emrin e përdoruesit dhe fjalëkalimin përkatës.
                        </p>
                        <p>
                            9.2 Përdoruesi ka përgjegjësi ruajtjen dhe
                            përdorimin e përshtatshëm të llogarisë së tij,
                            pavarësisht metodës që ai zgjedh për përdorimin e
                            platformës së Emetuesit IFJB CAPITAL SH.P.K
                            (web/mobile application), për ruajtjen dhe mbajtjen
                            e kredencialeve dhe për të gjithë Transaksionet që
                            do të kryhen në Llogarinë e Emetuesit IFJB CAPITAL
                            SH.P.K, duke përdorur kredencialet e tij.
                        </p>
                        <p>
                            9.3 Termat dhe Kushtet e Kontratës janë
                            konfidenciale dhe nuk bëhen publike pa pëlqimin e
                            Palës tjetër, përveç në rastet e parashikuara nga
                            ligjet e Republikës së Kosovës.
                        </p>
                        <h5>
                            Neni 10. Përpunimi dhe saktësia e të dhënave
                            personale të përdoruesit
                        </h5>
                        <p>
                            10.1 Mbrojtja e privatësisë dhe të dhënave personale
                            janë çështje të një rëndësie të veçantë dhe Emetuesi
                            zbaton në mënyrë rigoroze kërkesat e Ligjit nr.
                            06/l-082 datë 30.01.2019 “Për Mbrojtjen e të Dhënave
                            Personale” si dhe aktet tjera relevante nënligjore
                            përkatëse dhe merr përsipër të përmbushë çfarëdolloj
                            detyrimi ligjor për këtë qëllim. <br />
                            10.2 Të Dhënat Personale të të gjithë Përdoruesve do
                            të mblidhen dhe përpunohen më tej ekskluzivisht për
                            qëllimet e regjistrimit dhe ofrimit të shërbimit të
                            Emetuesit IFJB CAPITAL SH.P.K. <br />
                            10.3 Me pranimin e kësaj kontrate, Përdoruesi
                            konsiderohet se ka dhënë pëlqimin e tij/saj
                            eksplicit dhe të qartë për mbledhjen, transferimin,
                            ruajtjen, përdorimin dhe përpunimin e të Dhënave
                            Personale të tij/saj në kontekstin e përdorimit të
                            Emetuesit IFJB CAPITAL SH.P.K. <br />
                            10.4 Me pranimin e kësaj kontrate, Përdoruesi do të
                            konsiderohet se ka kuptuar dhe me vullnet të lirë
                            dhe në mënyrë eksplicite autorizon Emetuesin IFJB
                            CAPITAL SH.P.K t’i transmetojë ofruesve të saj
                            shërbimit dhe/ose kontraktorëve të saj për përpunim,
                            të Dhënat Personale të Përdoruesit, për qëllimet e
                            ofrimit të shërbimit. <br />
                            10.5 Me pranimin e kësaj kontrate, Përdoruesi jep
                            pëlqimin e tij/saj eksplicit për të marrë komunikime
                            lidhur me përdorimin dhe shërbimet e ofruara nga
                            Emetuesi IFJB CAPITAL SH.P.K, me SMS dhe/ose përmes
                            kanaleve të tjera të komunikimit që mund të jenë të
                            disponueshëm edhe për Emetuesin IFJB CAPITAL SH.P.K
                            edhe për Përdoruesin. Përdoruesi ka të drejtë ta
                            tërheqë këtë pëlqim në çdo kohë. <br />
                            10.6 Emetuesi IFJB CAPITAL SH.P.K dhe Përdoruesi do
                            të zbatojnë siguri të nivelit të lartë, masa teknike
                            dhe organizative që do të bëjnë të mundur
                            minimizimin e ndërhyrjeve të paautorizuara në
                            sistem, ndryshimeve dhe humbjeve të të dhënave.
                            <br />
                            10.8 Emetuesi IFJB CAPITAL SH.P.K do të ruajë të
                            dhënat e Përdoruesit për jo më shumë se 5 (pesë)
                            vjet pas mbarimit të kësaj kontrate.
                        </p>
                        <h5>Neni 11. Detyrimet e Palëve në Kontratë</h5>
                        <p>
                            11.1 Përveç detyrimeve të theksuara deri me tani në
                            Kontratë, Emetuesit IFJB CAPITAL SH.P.K merr
                            përsipër
                        </p>
                        <p className="leftpaddd">
                            11.1.1 Për të hapur për Përdoruesin llogarinë e
                            specifikuar në Kontratë në Euro ose në një tjetër
                            monedha e rënë dakord nga Palët <br />
                            11.1.2 Për të kredituar fondet të transferuara ose
                            paguara në para të gatshme dhe të depozituara në
                            llogarinë e Emetuesit, të emetojë para elektronike
                            me vlerën nominale të parasë dhe t'i kreditojë ato
                            në llogaria e Përdoruesit. <br />
                            11.1.3 Për të ekzekutuar urdhër pagesat e paraqitura
                            nga Përdoruesi ose përfaqësuesi i tij në përputhje
                            me termat dhe kushtet e përcaktuara nga kontrata
                            midis Emetuesit dhe Përdoruesit dhe ligjet e
                            Republikës së Kosovës, me kusht që llogaria përmban
                            fonde të mjaftueshme për ekzekutimin e
                            urdhërpagesave dhe pagesën e tarifave për shërbimet
                            e kryera dhe operacionet e kryera nga Emetuesi në
                            përputhje me Tarifat Standarde në kohën e ditës së
                            punës të Emetuesit, por jo më vonë sesa përcaktohet
                            nga marrëveshjet midis Emetuesit dhe Përdoruesit dhe
                            ligjet e Republikës së Kosovës. <br />
                            11.1.4 Për të siguruar vetëm informacion në lidhje
                            me statusin e llogarisë, si dhe pasqyrat e
                            llogarisë, të cilat tregojnë gjendjen e llogarisë
                            dhe operacionet e kryera ndaj Përdoruesit si dhe
                            përfaqësuesit të Përdoruesit. Mund të ofrojë
                            dëshmitë e pagesave, të printuara në letër apo
                            përmes verifikimit dhe/ose shkarkimit përmes
                            internetit (online). Në mungesë të Përdoruesit
                            pëlqimin, për të siguruar informacionin vetëm në
                            rastet e parashikuara nga ligjet e Republikës e
                            Kosovës. <br />
                            11.1.5 Për t'i dhënë këshilla Përdoruesit për
                            çështjet e menaxhimit të llogarisë. <br />
                            11.1.6. Të ofrojë shërbimin e Emetuesit IFJB CAPITAL
                            SH.P.K gjatë gjithë kohës (24/7), përveç nëse ka
                            ndodhur ndonjë avari teknike apo llogaria e
                            Përdoruesi është subjekt i dyshimeve për vepra të
                            paligjshme apo një urdhër i plotfuqishëm i
                            autoritetit përkatës ka detyruar pezullimin e
                            shërbimit.
                        </p>
                        <p>
                            11.2 Përveç detyrimeve të theksuara deri me tani në
                            Kontratë, në emër të shërbimit Përdoruesi detyrohet:
                        </p>
                        <p className="leftpaddd">
                            11.2.1 Kur hapni, përpunoni dhe mbyllni llogarinë,
                            të paraqisni dokumentet e kërkuara Emetuesit IFJB
                            CAPITAL SH.P.K, duke konfirmuar të drejtën e
                            Përdoruesit ose përfaqësuesit të Përdoruesit për të
                            menaxhuar llogarinë e Përdoruesit dhe fondet në të.
                            <br />
                            11.2.2 T’i paguaj Emetuesit IFJB CAPITAL SH.P.K një
                            tarifë të dakorduar për shërbimet e kryera dhe
                            transaksionet ekzekutuar nga Emetuesit IFJB CAPITAL
                            SH.P.K, të cilin Emetuesit IFJB CAPITAL SH.P.K ka të
                            drejtë ta zbresë nga llogaria në ditën kur është
                            kryer operacioni. Nëse, në ditën e transaksionit,
                            llogaria nuk ka fonde të mjaftueshme për të zbritur
                            tarifën e Emetuesit IFJB CAPITAL SH.P.K, Përdoruesi
                            pajtohet që tarifa për transaksionin e kryer ose
                            shërbimet e kryera do të zbritet në çdo ditë tjetër
                            kur gjendja e llogarisë së përdoruesit është e
                            mjaftueshme. <br />
                            11.2.3 Të përdor llogarinë e Emetuesit vetëm për
                            qëllime të ligjshme. <br />
                            11.2.4 Respektimin e të drejtave të autorit dhe të
                            drejtat e pronësisë intelektuale të Emetuesit IFJB
                            CAPITAL SH.P.K; <br />
                            11.2.5 Të njoftojë menjëherë Emetuesin për fondet e
                            kredituara ose debituara gabimisht, apo
                            transaksionet e tjera të gabuara të llogarisë. Në
                            rast të fondeve të pamjaftueshme për të debitoni
                            shumat e kredituara gabimisht në llogari, Përdoruesi
                            pa kushte merr përsipër brenda 3 (tre) ditëve të
                            punës nga dita e marrjes së kërkesës nga Emetuesi të
                            kthejë fondet e kredituara gabimisht tek Emetuesi.;
                            <br />
                            11.2.6 Në rast të ndonjë ndryshimi në të dhënat e
                            dhëna Emetuesit nga Përdoruesi (emri, mbiemri, emri
                            i personit juridik, vendbanimi ose adresa e
                            regjistrimit, personat e autorizuar për të menaxhuar
                            fondet e llogarisë ose të dhënat e tyre ose të
                            tjeter informacione i dhënë më parë Emetuesit),
                            menjëherë, por jo më vonë se brenda 3 (tre) ditëve
                            të punës, raportoni këtë tek Emetuesi dhe siguroni
                            mbështetje dokumentet. Përdoruesi, nëse nuk ka
                            përmbushur siç duhet detyrimet e parashikuara në
                            këtë kontrate, është përgjegjëse i vetëm për të
                            gjitha pasojat që dalin prej saj; <br />
                            11.2.7 Për të siguruar që përdorimi i llogarisë nuk
                            shkel kërkesat e marrëveshjen e lidhura midis
                            Emetuesit dhe Përdoruesit dhe aktet ligjore, si dhe
                            që fondet e përfshira në Llogari nuk përdoren për
                            qëllime të paligjshme ose aktivitetet terroriste ose
                            për qëllime të shpëlarjes së parasë, ose do të
                            rezultonte nga veprimtaria ilegale <br />
                            11.2.8 Përdorni llogarinë në përputhje me termet dhe
                            kushtet e përdorimit të saj, sigurohuni që sigurinë
                            dhe konfidencialitetin e llogarisë dhe të dhënave
                            për qasje, dhe të ndërmarrë hapa aktivë për
                            parandaluar që llogaria dhe të dhënat e qasje së saj
                            të mos përdoren nga palë të treta të paautorizuara.
                            <br />
                            11.2.9 Pasi të jeni të vetëdijshëm për përdorimin e
                            paautorizuar të llogarisë dhe/ose qasjen në llogari
                            ose për të dhënat e qasjes së saj, si dhe provat ose
                            dyshimet se një informacion i tillë është bërë e
                            njohur për palët e treta, Përdoruesi duhet
                            menjëherë, por jo më vonë se brenda 1 (një) dite
                            pune, të njoftoni Emetuesin ose subjektin e caktuar
                            prej tij.
                        </p>
                        <p>
                            11.3 Konfidencialiteti – Informacioni konfidencial
                            ("Informacioni Konfidencial") i referohet çdo të
                            dhëne ose informacioni në lidhje me të dhënat
                            personal apo biznesore të Përdoruesit , i cili në
                            mënyrë të arsyeshme do të konsiderohej si pronësi e
                            Përdoruesit, përfshirë, por pa u kufizuar në, futjen
                            e të dhënave gjatë hapjes së llogarisë,
                            transaksionet e ekzekutuara dhe informacione tjera
                            që nuk njihet përgjithësisht në industrinë e
                            Përdoruesit dhe ku publikimi i atij Informacioni
                            Konfidencial mund të pritet që të shkaktojë dëm për
                            Përdoruesin.
                        </p>
                        <h5>Neni 12. Kohëzgjatja e Ruajtjes së Shënimeve</h5>
                        <p>
                            12.1 Emetuesi IFJB CAPITAL SH.P.K do të ruajë të
                            gjitha shënimet, përfshirë por duke mos u kufizuar
                            në gjendjen e llogarisë bankare, kontratën në mes të
                            palëve, për një periudhë pesë (5) vjeçare nga
                            transaksioni / aktiviteti i fundit.
                        </p>
                        <h5>Neni 13. Përjashtimi i Përgjegjësisë </h5>
                        <p>
                            13.1 Emetuesi ka të drejt të refuzon të ekzekuton
                            urdhrin e dhënë të transaksionit nga Përdoruesi nëse
                            ekziston dyshimi se urdhri i transaksionit është
                            paraqitur nga një person i paautorizuar nga
                            Përdoruesi ose dokumente të paraqitura tek Emetuesi
                            është i falsifikuar dhe kërkon dokumente dhe/ose
                            informacion shtesë për të të paraqitet.
                        </p>
                        <p>
                            13.2 Nëse fondet janë kredituar gabimisht në llogari
                            ose janë zbritur gabimisht nga llogaria, ose vërehen
                            gabime të tjera në transaksionet me Llogarinë, për
                            të korrigjuar këto gabime pa pëlqimin shtesë të
                            Përdoruesit.
                        </p>
                        <p>
                            13.3 Institucioni nuk është përgjegjës për
                            marrëdhëniet dhe kërkesat midis paguesve dhe të
                            paguarve dhe nuk i heton ato.
                        </p>
                        <p>
                            13.4 Në zbatimin e një vendimi gjyqësor ose në raste
                            të tjera të parashikuara nga ligjet e Republikës së
                            Kosovës, tërheq fonde nga Llogaria pa pëlqimin e
                            Përdoruesit. Emetuesi IFJB CAPITAL SH.P.K nuk
                            garanton operim të pandërprerë të operacioneve.
                            Emetuesi IFJB CAPITAL SH.P.K nuk do të jetë
                            përgjegjës për pasojat që dalin nga parregullsitë në
                            sistemin e operimeve të cilat ndodhin për shkak të
                            arsyeve që nuk janë nën kontrollin e Emetuesit IFJB
                            CAPITAL SH.P.K.
                        </p>
                        <p>
                            13.5 Mbetet në barrën e përdoruesve që të marrin të
                            gjitha informacionet dhe të veprojnë me kujdes të
                            shtuar para pagimit të produktit apo shërbimit apo
                            urdhërimit të çdo transaksioni tjetër të kryer.
                            Emetuesi IFJB CAPITAL SH.P.K në asnjë rrethanë nuk
                            është përgjegjës për mos-përmbushjen apo përmbushjen
                            e parregullt të detyrimit dhe/apo dëmet e pësuara në
                            këtë aspekt nga Përdoruesi.
                        </p>
                        <p>
                            13.6 Përdoruesi është përgjegjës për informacionin
                            të pavërtete dhe të pasaktë që i jepet Emetuesit dhe
                            rimburson të gjitha humbjet e shkaktuara nga
                            Emetuesi në përputhje me procedurat e parapara me
                            ligje dhe akte të tjera ligjore të Republikës së
                            Kosovës.
                        </p>
                        <h5>Neni 14. Ligji i aplikueshëm</h5>
                        <p>
                            14.1 Interpretimi i kësaj marrëveshje do të bëhet në
                            bazë të ligjeve të aplikueshme në Republikën e
                            Kosovës.
                        </p>
                        <h5>Neni 15. E drejta e Ankesës apo Kërkesës</h5>
                        <p>
                            15.1 Për ndonjë paknaqësi, palët kanë të drejtë të
                            kërkesës apo ankesës. Kërkesa apo Ankesa mund të
                            adresohet në njërën nga adresat në vijim: në adresën
                            elektronike zyrtare të Emetuesi IFJB CAPITAL SH.P.K
                            info@capital-ks.com, apo në numrin e telefonit të
                            Emetuesi IFJB CAPITAL SH.P.K +38349/197999. <br />
                            15.2 Të drejtat lidhur me kërkesat dhe ankesat e
                            Perdoruesit trajtohen përmes politikës dhe
                            procedurës së trajtimit të ankesave të Emetuesi IFJB
                            CAPITAL SH.P.K. <br />
                            15.3 Ankesa mund të prashtrohet edhe prane
                            autoritetit mbikeqyrese, respektivishit Divisionit
                            të Ankesave të Bankes Qendrore të Kosovës me adres:
                            Rr. Garibaldi nr 33 Prishtinë, Kosovës, në numrin e
                            telefonit +383 38 222 055 303, apo në e-mail:
                            ankesat@bqk-kos.org.
                        </p>
                        <h5>Neni 16. Ndryshim dhe validiteti i Kontratës</h5>
                        <p>
                            16.1 Ndryshimi i kushteve apo amandamentimi i kësaj
                            kontrate është i mundshëm në bazë të kërkesës së
                            palëve dhe pajtimit të palëve. Palët pajtohen që të
                            gjitha amandamentet dhe aneks marrëveshjet janë
                            efektive vetëm kur janë bërë në formën e shkruar nga
                            Emetuesi IFJB CAPITAL SH.P.K dhe Përdoruesi – palët.
                            <br />
                            16.2 Në rast të ndryshimit të termeve dhe kushteve
                            të kësaj kontrate, Emetuesi IFJB CAPITAL SH.P.K do
                            ta njoftoj Përdoruesi për propozimet e ndryshimit të
                            kësaj kontrate një (1) muaj nga data e hyrjes në
                            fuqi. <br />
                            16.3 Përdoruesi ka të drejtën e ndërprerjes së kësaj
                            kontrate në rast se nuk është i kënaqur me
                            ndryshimet e bëra, brenda periudhës kohore të
                            paraparë në paragrafin e mësipërm, pa ndonjë gjobë
                            apo kosto shtesë. <br />
                            16.4 Nëse ndonjë nen i kësaj kontrate përfundon me
                            një amandament legjislativ apo organ kompetent, të
                            gjitha nenet tjera do të vazhdojnë të jenë efektive.
                        </p>
                        <h5>Neni 17. Mbyllja e llogarisë</h5>
                        <p>
                            17.1 Me kërkesën e Përdoruesit, Emetuesi IFJB
                            CAPITAL SH.P.K do ta mbyllë llogarinën renda pesë
                            (5) ditësh pune. Në rast se Përdoruesi nuk ka
                            tërhequr mjetet nga llogaria e Emetuesit IFJB
                            CAPITAL SH.P.K, deri në mbylljen e saj nga Emetuesi
                            IFJB CAPITAL SH.P.K, të njëjtat do të asgjësohen, pa
                            kthim.
                        </p>
                        <p>
                            17.2 Përdoruesi nuk mund të mbyllë një llogari nëse
                            ka detyrime të pashlyera ndaj Emetuesit IFJB CAPITAL
                            SH.P.K.
                        </p>
                        <p>
                            17.3 Në përputhje me legjislacionin e aplikueshëm
                            Emetuesi IFJB CAPITAL SH.P.K mund të pezullojë,
                            kufizojë ose përfundojë, tërësisht ose pjesërisht,
                            ofrimin e Shërbimeve Emetuesi IFJB CAPITAL SH.P.K
                            dhe/ose të mbyllë Llogarinë e Përdoruesit pa
                            informuar atë dhe/ose pa asnjë detyrim çfarëdo qoftë
                            veprimet e mundshme për të informuar Përdoruesit që
                            ky veprim është kryer ose do të kryhet në rrethanat
                            e mëposhtme:
                        </p>
                        <p className="leftpadd">
                            17.3.1Nëse Emetuesi IFJB CAPITAL SH.P.K kupton apo
                            ka arsye të besojë se telefoni apo fjalëkalimi i
                            Përdoruesit për përdorimin e Shërbimeve të Emetuesit
                            IFJB CAPITAL SH.P.K po përdoret ose është përdorur
                            më parë në mënyrë të paautorizuar, të paligjshme, të
                            papërshtatshme ose për veprimtari kriminale; <br />
                            17.3.2nëse Përdoruesi nuk përmbush kërkesat e kësaj
                            Kontrate në lidhje me Emetuesit IFJB CAPITAL SH.P.K;
                            <br />
                            17.3.3nëse Përdoruesi njofton se pajisja celulare ka
                            humbur apo është vjedhur apo fjalëkalimi ka humbur;
                            <br />
                            17.3.4për arsye që janë jashtë kontrollit të
                            Emetuesit IFJB CAPITAL SH.P.K, duke përfshirë por pa
                            u kufizuar, ne forcën madhore, masa të organeve
                            përkatëse rregullatorë apo ndryshime ne
                            legjislacion.
                        </p>
                        <h5>
                            Neni 17. Kohëzgjatja dhe përfundimi i Marrëveshjes
                        </h5>
                        <p>
                            17.1 Kontrata hyn në fuqi ditën e nënshkrimit dhe
                            është e vlefshme pafundësisht deri në përfundimi i
                            Marrëveshjes. <br />
                            17.2 Përdoruesi mund ta ndërpres kontratën, pas
                            dhënies me shkrim të njoftimit për ndërprerje prej
                            tridhjetë (30) ditësh. Emetuesi IFJB CAPITAL SH.P.K
                            po ashtu, ruan të drejtën për ta ndërprerë
                            marrëveshjen në mënyrë të njëanshme, pas dhënies me
                            shkrim të njoftimit për ndërprerje prej
                            gjashtëdhjetë (60) ditësh. Megjithatë, në rast të
                            kryerjes nga ana e Përdoruesi të aktiviteteve të
                            paligjshme të parapara me legjislacionin në fuqi,
                            Emetuesi IFJB CAPITAL SH.P.K rezervon të drejtën që
                            pa njoftim paraprak ta ndërpresë marrëveshjen dhe të
                            pezulloj llogarinë deri në një vendim të
                            plotfuqishëm të autoriteteve përkatëse.
                        </p>
                        <h5>Neni 18. Zgjidhja e mosmarrëveshjeve </h5>
                        <p>
                            Në rast kontesti ndërmjet palëve kontraktuese, palët
                            mund të përdorin negociatat si formë për të zgjidhur
                            mosmarrëveshjet. Në çdo rast tjetër kontesti do të
                            zgjidhet në Gjykatën kompetente.
                        </p>
                        <div className="row">
                            <div className="col-6">
                                <h6>Institucionit Financiar: </h6>
                                <p>IFJB CAPITAL SH.P.K, i licencuar nga BQK</p>
                                <p>NUI: 810797623</p>
                                <h6>Nusret Hasani, Drejtor</h6>
                                <p>_________________________</p>
                                <p>Dt.:</p>
                            </div>
                            <div className="col-6">
                                <h6>Përdoruesi: </h6>
                                <p>_________________________</p>
                                <p>Nr. Personal.: </p>
                                <p>Nr. Tel. </p>
                                <p>Nënshkrimi: </p>
                                <p>Dt.: </p>
                            </div>
                        </div>
                        <h5 className="paddingtop">Shtojcat:</h5>
                        <p>
                            Shtojca nr. 1 – Formular identifikimi i personit te
                            ekspozuar politikisht (PEP) <br />
                            Shtojca nr. 2 - Formular mbi burimin e prejardhjes
                            së fondeve dhe përcaktimin e pronësisë së
                            përfituesit <br />
                            Shtojca nr. 3 - Pajtueshmëria e aktit ligjor për
                            llogarite e jashtme (FATCA) <br />
                            Shtojca nr. 4 –Identifikimi i Pronarëve Përfitues
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default termsandcontitionspriv;
